import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../nav_bar/Navbar";
import Footer from "../../footer/Footer";
import { fetchCategories } from "./officialSentenceService";
import "./OfficialSentenceListPage.css";

const OfficialSentenceListPage = () => {
 const [categories, setCategories] = useState([]);
 const [loading, setLoading] = useState(false);
 const [search, setSearch] = useState("");
 const navigate = useNavigate();

 useEffect(() => {
 const load = async () => {
 setLoading(true);
 const res = await fetchCategories({ search: search || undefined });
 if (res.status === 200 && res.data?.status) {
 setCategories(res.data.data || []);
 } else { setCategories([]); }
 setLoading(false);
 };
 load();
 }, [search]);

 return (
 <>
 <Navbar />
 <div className="os-page">
 <h1 className="os-title">🏢 Official Sentences</h1>
 <p className="os-subtitle">Professional English sentences for workplace and formal situations.</p>

 <div className="os-filters">
 <input
 className="os-search"
 type="text"
 placeholder="Search categories..."
 value={search}
 onChange={(e) => setSearch(e.target.value)}
 />
 </div>

 {loading ? (<p className="os-loading">Loading...</p>) : categories.length === 0 ? (<p className="os-empty">No categories available yet.</p>) : (
 <div className="os-grid">
 {categories.map((c) => (
 <div key={c.id} className="os-card" onClick={() => navigate(`/study/official-sentences/category/${c.id}`)}>
 <span className="os-card-icon">{c.icon || "📂"}</span>
 <h3 className="os-card-title">{c.title}</h3>
 {c.description && <p className="os-card-desc">{c.description}</p>}
 <span className="os-card-count">{c.sentenceCount || 0} sentences</span>
 </div>
 ))}
 </div>
 )}
 </div>
 <Footer />
 </>
 );
};

export default OfficialSentenceListPage;
